module.exports = __webpack_public_path__ + "static/media/Bot3.1f7ef0d4.png";